import React,{ useRef, useEffect, useState } from 'react'
import PropTypes from 'prop-types'

export default function FeaturesList({ plan }) {
  const [expanded, setExpanded] = useState(false)
  const scrollRef = useRef(null)
  const hasOverflow = plan.included.length > 6
  const visibleItems = expanded ? plan.included : plan.included.slice(0, 6)
  //forcing a mini scroll that goes to the bottom when opened bc spacing was too weird
  useEffect(() => {
    if(expanded && scrollRef.current) {
      const scrollElement = scrollRef.current
      requestAnimationFrame(() => {
        scrollElement.scrollTo({ top: scrollElement.scrollHeight, behavior: 'smooth' })
      })
    }
    if(!expanded && scrollRef.current) {
      scrollRef.current.scrollTop = 0
    }
  }, [expanded])

  return (
    <div className="info-list margin-top-md">
      <p className="bold">What’s Included for 30 days</p>

      {expanded ? (
        <div ref={scrollRef} className="features-scroll">
          {plan.included.map((item, idx) => (
            <div key={idx} className="api-included">
              <i className="fas fa-check-circle margin-right-lg" />
              <p>{item}</p>
            </div>
          ))}
        </div>
      ) : (
        visibleItems.map((item, idx) => (
          <div key={idx} className="api-included">
            <i className="fas fa-check-circle margin-right-lg" />
            <p>{item}</p>
          </div>
        ))
      )}

      {hasOverflow && (
        <a
          type="button"
          className="see-more-btn btn btn-round btn-xs btn-default btn-block"
          onClick={e => {
            e.stopPropagation()
            setExpanded(!expanded)
          }}
          style={{ color: 'inherit', textDecoration: 'none', cursor: 'pointer' }}
        >
          {expanded ? (
            <>View less <i className="fas fa-caret-up margin-left-md" /></>
          ) : (
            <>View more <i className="fas fa-caret-down margin-left-md" /></>
          )}
        </a>
      )}
    </div>
  )
}
FeaturesList.propTypes = {
    plan:        PropTypes.object.isRequired
  }